module.exports = __webpack_public_path__ + "img/badge_googleplay.c5bc85dd.png";